import {
    MODAL_IS_OPEN,
  } from '../../actions/modal';

export default function modal(state = {}, action) {
    switch (action.type) {
        case MODAL_IS_OPEN:
            return Object.assign({}, state, action.payload);
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/reducers/modal/index.js